import { useState } from 'react';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import { Outlet } from "react-router-dom";
import AdminDrawer from './AdminDrawer';
import AdminAppBar from './AdminAppBar';
import { styled, Toolbar } from '@mui/material';
import { GlobalConfirmDialog } from 'src/_modules/common';

const ContentWrapper = styled('div')(({ theme }) => ({
    paddingTop: `calc(56px + 16px)`,
    [`${theme.breakpoints.up("xs")} and (orientation: landscape)`]: {
        paddingTop: `calc(48px + 16px)`,
    },
    [theme.breakpoints.up("sm")]: {
        paddingTop: `calc(64px + 16px)`,
    },
    paddingBottom: '16px',
    paddingInline: '16px',
}));

export default function ClippedDrawer() {
    const [openDrawer, setOpenDrawer] = useState(false)
    const toggleDrawerHandler = () => {
        setOpenDrawer((prevState) => !prevState)
    }
    return (
        <Box sx={{ display: { xs: "block", lg: "flex" } }}>
            <CssBaseline />
            <AdminAppBar toggleDrawer={toggleDrawerHandler} />
            {/* minWidth: 0 (here and on <main>) lets the content shrink to the space beside the drawer; without it wide
                tables/tab rows push the page past the viewport, where html's overflow-x: hidden makes it unreachable */}
            <Box sx={{ display: { xs: "block", lg: "flex" }, flexGrow: 1, minWidth: 0 }}>
                <AdminDrawer openDrawer={openDrawer} toggleDrawer={toggleDrawerHandler} />
                <Box component="main" sx={{ flexGrow: 1, minWidth: 0, py: 3, px: { xs: 1, md: 3 } }}>
                    <GlobalConfirmDialog />
                    <Toolbar />
                    <Container maxWidth={false}>
                        <Outlet />
                    </Container>
                </Box>
            </Box>
        </Box>
    );
}